import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import theme from '~/theme';
import Routes from '~/routes';
import Fonts from './theme/Fonts';
import MediaQuery from './globalScript/MediaQuery';
import versionInfo from '~/versionInfo';

console.table(versionInfo);
function App() {
  return (
    <RecoilRoot>
      <ChakraProvider theme={theme}>
        <Fonts />
        <MediaQuery />
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </ChakraProvider>
    </RecoilRoot>
  );
}

export default App;
